import styled from 'styled-components';

const AboutDesc = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  align-content: center;
  justify-content: space-between;
  background-color: transparent;
  h1 {
    font-weight: lighter;
  }
  @media (max-width: 500px) {
    flex-direction: column-reverse;
  }
`;

export const AboutText = styled.p`
  width: 50%;
  padding: 24px;
  background-color: transparent;
  flex-direction: column;
  @media (max-width: 500px) {
    width: 100%;
  }
`;
const AboutImg = styled.img`
  position: relative;
  height: auto;
  width: 40%;
  object-fit: cover;
  background-position: center;
  @media (max-width: 500px) {
    width: 100%;
    height: 128px;
    opacity: 0.4;
  }
`;

const Timelapse = styled.div`
    background: white;
    padding: 24px;
    margin: 12px;
    h2, h4 {
      font-weight: lighter;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    text-align: center;
`;

const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  @media (max-width: 500px) {
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
  }
`;


export {AboutDesc, Timelapse, AboutImg, Gallery};
